import React from 'react';
import {MainBannerComponent, ServicesIconsComponent, ServicesBulletedComponent, ServicesBlockComponent, SliderComponent, MemberComponent, TextMediaComponent, ContactDetailsComponent} from '../../../../common/CMS/components';

export const Media2 = (props) => {

  const {mainBannerSection, servicesIconsSection, servicesBulletedSection, sliderSection, contactDetailsSection, mediaSection, memberSection, servicesBlockSection } = props.data.content;

  return <div className="row media-two">

    { mainBannerSection && <MainBannerComponent content={mainBannerSection} /> }

    { servicesIconsSection && <ServicesIconsComponent content={servicesIconsSection}/> }

    { sliderSection && <SliderComponent images={sliderSection.images} /> }

    { servicesBulletedSection && <ServicesBulletedComponent content={servicesBulletedSection} /> }

    { servicesBlockSection && <ServicesBlockComponent content={servicesBlockSection} /> }

    { memberSection && <MemberComponent content={memberSection} /> }

    { mediaSection && <TextMediaComponent content={mediaSection} /> }

    { contactDetailsSection && <ContactDetailsComponent content={contactDetailsSection} /> }

  </div>
};


// WEBPACK FOOTER //
// src/client/components/site/features/partnerships/templates/Media2.js